import React from "react"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { LayerEntityType } from "@nova/schemas"
import { layerTypeIconSources } from "features/events/eventLabels"
import { ProfilePhoto } from "features/data-management/workspace/workspace/body/settings-and-collaborators/profile/ProfilePhoto"

export type NotificationBadge = "success" | "failure"

const IconBadge = ({ badge }: { badge: NotificationBadge }) => (
    <div className="absolute -top-1 -right-1">
        <Icons.CustomIcon
            Icon={badge === "success" ? Icons.Checkmark : Icons.Exclamation}
            size={{ width: 12, height: 12 }}
            className={classNames(
                "rounded-full text-white",
                badge === "success" ? "bg-green-500" : "bg-red-500"
            )}
        />
    </div>
)

const IconFrame = ({ children }: { children: React.ReactNode }) => (
    <div className="w-8 h-8 rounded-lg bg-gray-800 flex items-center justify-center overflow-hidden">
        {children}
    </div>
)

export const AvatarIcon = ({
    userId,
    fullName,
}: {
    userId: string
    fullName: string | undefined
}) => (
    <div className="w-8 h-8 rounded-lg overflow-hidden">
        <ProfilePhoto userId={userId} fullName={fullName ?? ""} />
    </div>
)

export const ComponentIcon = ({
    Icon,
    className,
}: {
    Icon: Icons.IconComponent
    className?: string
}) => (
    <IconFrame>
        <Icons.Icon Icon={Icon} iconClassName={className} />
    </IconFrame>
)

export const LayerTypeIcon = ({
    layerType,
    badge,
}: {
    layerType: LayerEntityType
    badge: NotificationBadge
}) => {
    const source = layerTypeIconSources[layerType] ?? Icons.Processing
    return (
        <>
            <IconFrame>
                {"url" in source ? (
                    <img src={source.url} alt="" className="w-5 h-5" />
                ) : (
                    <Icons.Icon Icon={source} />
                )}
            </IconFrame>
            <IconBadge badge={badge} />
        </>
    )
}
